import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ShowButton,
  FunctionField,
  TextInput,
  ListProps,
  TopToolbar,
  FilterButton,
  CreateButton,
  Button,
  useRedirect,
  useGetIdentity,
} from "react-admin"
import { verifyAccess } from "../../utils/resourcePermissons"
import EditIcon from "@mui/icons-material/Edit"

const driversFilters = [
  <TextInput source="email" label="EMAIL" alwaysOn variant="standard" />,
  <TextInput source="phone" label="PHONE" alwaysOn variant="standard" />,
  <TextInput source="rails_ids" label="RAILS ID" variant="standard" />,
  <TextInput source="first_name" label="FIRST NAME" variant="standard" />,
  <TextInput source="last_name" label="LAST NAME" variant="standard" />,
]

const BulkEditButton: React.FC = (props: any) => {
  const redirectTo = useRedirect()
  return (
    <Button color="primary" label="Bulk Edit" onClick={() => redirectTo(`/drivers/bulk`, props.basePath)}>
      <EditIcon />
    </Button>
  )
}

const ListActions = (props: any) => {
  const { identity } = useGetIdentity()
  const isCompliance = identity?.driverRoles.includes('compliance')
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      {isCompliance && <BulkEditButton {...props} />}
    </TopToolbar>
  )
}

export const DriversList: React.FC<ListProps> = (props) => (
  <List {...props} filters={driversFilters} exporter={false} bulkActionButtons={false} actions={<ListActions {...props} />}>
    <Datagrid>
      <TextField source="id" sortable={false} label="ID" />
      <FunctionField render={(record: any) => `${record.first_name}${record.last_name ? " " + record.last_name : ""}`} label="Name" />
      <TextField source="email" sortable={false} label="Email" />
      <TextField source="phone" sortable={false} label="Phone" />
      <TextField source="active" sortable={false} label="Active" />
      <TextField source="employment_status" sortable={false} label="Employment Status" />
      <DateField source="created_at" sortable={false} label="Joined" />
      {verifyAccess(props.permissions, "driver", "update") ? <EditButton /> : null}
      <ShowButton />
    </Datagrid>
  </List>
)
